<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  export let dropdownItems = []
  export let selected
  let showDropdown = false

  let dropdown

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />

<div bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    class="flex h-9 min-h-full w-full items-center justify-center gap-3 rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-blue-500 hover:text-white focus:outline-none active:bg-blue-600 active:text-white disabled:cursor-not-allowed dark:bg-darkgray dark:text-slate-200 dark:hover:bg-blue-500"
  >
    <h1 class="text-xs font-medium">{selected} Days</h1>
    <i class="fa-solid fa-chevron-down" />
  </button>
  <div class:hidden={!showDropdown} class="absolute top-12 right-12 z-30 rounded-md border border-[#a0a1a580] bg-white p-1 dark:bg-darkgray">
    {#each dropdownItems as item}
      <button
        on:click={() => {
          showDropdown = false
          dispatch("onSelect", item)
        }}
        class="{selected == item ? 'bg-blue-500 text-white' : 'text-gray-500 hover:bg-[#f7f7f7] dark:hover:bg-black'} w-full rounded-md py-1.5 px-3 text-xs font-medium dark:hover:text-white"
      >
        {item} Days
      </button>
    {/each}
  </div>
</div>
